// Iter 41 — Field-Level Dependencies: shared labels / colours. Pure, no React.
export const REFERENCE_TYPES = [
  "read", "write", "compare", "assign", "key", "display", "input", "output", "join", "call_parameter", "unknown",
];
export const ORIGINS = ["business_rule", "source_parser", "dds_parser", "dspgmref", "dspffd", "manual", "unknown"];
export const CONFIDENCES = ["high", "medium", "low"];

export const CONFIDENCE_META = {
  high:   { label: "High",   hint: "Program-to-file link confirmed (parser file decl or DSPPGMREF) and the field sits in exactly one candidate file.", bg: "#defbe6", fg: "#0e6027", border: "#a7f0ba" },
  medium: { label: "Medium", hint: "The field name exists in exactly one catalogued file, but nothing ties this program to that file.", bg: "#fff8e1", fg: "#8a6d00", border: "#f1c21b" },
  low:    { label: "Low",    hint: "Ambiguous (several files carry this field) or not in the DSPFFD catalog — lineage deliberately left unresolved.", bg: "#f4f4f4", fg: "#525252", border: "#c6c6c6" },
};

export const ORIGIN_LABEL = {
  business_rule: "Business rule",
  source_parser: "Source parser",
  dds_parser: "DDS parser",
  dspgmref: "DSPPGMREF",
  dspffd: "DSPFFD",
  manual: "Manual",
  unknown: "Unknown",
};

export const TYPE_LABEL = {
  read: "read", write: "write", compare: "compare", assign: "assign", key: "key", display: "display",
  input: "input", output: "output", join: "join", call_parameter: "call parm", unknown: "unknown",
};

// Iter 42 — colour per access kind so read / write / assign / compare are distinguishable at a glance.
export const TYPE_META = {
  read:           { bg: "#defbe6", fg: "#0e6027", border: "#a7f0ba", hint: "Key argument of CHAIN / SETLL / SETGT / READE / READPE — value consumed as a key lookup." },
  write:          { bg: "#fff1f1", fg: "#a2191f", border: "#ffb3b8", hint: "Named in %fields() on WRITE / UPDATE — value written to the file." },
  assign:         { bg: "#edf5ff", fg: "#0043ce", border: "#a6c8ff", hint: "Target of EVAL / implicit assignment / MOVE / Z-ADD / CLEAR — value set by the program." },
  compare:        { bg: "#f6f2ff", fg: "#6929c4", border: "#d4bbff", hint: "Used in an IF / WHEN / DOW / DOU condition." },
  key:            { bg: "#e5f0ff", fg: "#00539a", border: "#bae6ff", hint: "Key field of the file (DDS)." },
  join:           { bg: "#e5f0ff", fg: "#00539a", border: "#bae6ff", hint: "Logical-file projection over the based-on file (DDS)." },
  call_parameter: { bg: "#f4f4f4", fg: "#525252", border: "#c6c6c6", hint: "Passed as a CALL / CALLP parameter — direction not proven." },
  // Iter 44 — display-file (DSPF) roles proven by the DDS usage code (col 38).
  display:        { bg: "#fff0f7", fg: "#9f1853", border: "#ffafd2", hint: "Display-file field that is neither typed into nor shown as data: hidden (usage H) or program-to-system (usage P). Proven by DSPF DDS." },
  input:          { bg: "#e5f0ff", fg: "#0043ce", border: "#78a9ff", hint: "Input-capable screen field — DSPF DDS usage I or B. The user can type into it." },
  output:         { bg: "#e8daff", fg: "#6929c4", border: "#be95ff", hint: "Output/display screen field — DSPF DDS usage O, B, M (message) or blank (output by DDS default)." },
  unknown:        { bg: "#ffffff", fg: "#6f6f6f", border: "#8d8d8d", hint: "Field is referenced but the access kind is not provable (%subst target, PARM, DSPLY…). Never promoted by guessing." },
};
export const IO_KINDS = ["read", "write", "assign", "compare", "unknown"];

export const confidenceMeta = (c) => CONFIDENCE_META[c] || CONFIDENCE_META.low;
export const originLabel = (o) => ORIGIN_LABEL[o] || o || "Unknown";
export const typeLabel = (t) => TYPE_LABEL[t] || t || "unknown";
export const typeMeta = (t) => TYPE_META[t] || TYPE_META.unknown;
